/* eslint-disable */
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';

import useAxios from '../../hooks/useAxios';
import { handleError } from '../../utils';
import './login.scss';
import MailIcon from '../../assets/icons/mail-icon.svg';
import LockIcon from '../../assets/icons/lock-icon.svg';
import { useAuth } from '../../hooks/useAuth';
import BayerLogo from '../../assets/icons/Bayer-logo.png';
// import LoginPic from '../../assets/images/Login-pic.jpg';
import LoginPic from '../../assets/images/LoginPic.png';

const isMockAPI = false;
const Login = () => {
  const toast = useRef<Toast | null>(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);

  const { login } = useAuth();
  const { post } = useAxios();

  const navigate = useNavigate();

  const handleLogin = async (e: any) => {
    e.preventDefault();

    if (!email.trim() || !password.trim()) {
    toast.current?.show({
      severity: 'warn',
      summary: 'Missing Fields',
      detail: 'Please enter both email and password.',
      life: 3000,
    });
    return;
  }
    if (email && password) {
      console.log('isMockAPI', isMockAPI);
      if (isMockAPI && email === 'user@example.com' && password === 'test1234') {
        localStorage.setItem('authToken', 'mock-auth-token');

        const user = {
          email: 'user@example.com',
          name: 'John Smith',
          exp: 1234567,
          accountId: 123,
          token: 'mock-auth-token',
          role: 'admin',
          user_id: 'user@example.com'
        };

        login(user);
      } else {
        const postData = new FormData();
        postData.append('email', email);
        postData.append('password', password);

        await post('/auth/login', postData).then((response: any) => {
          const { status } = response;
          if ([200, 201].includes(status) && response.data.data && !response.data.errors) {
            const userData = response.data.data;
            localStorage.setItem('authToken', userData.token);

            const user = {
              email: userData.user.email,
              name: `${userData.user.firstName} ${userData.user.lastName}`,
              token: userData.token,
              role: userData.user.role,
              user_id: userData.user_id
            };
            login(user);
          } else if ([200, 201].includes(status) && response.data.errors[0]) {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: response.data.errors[0] });
          }
        }).catch((error: any) => {
          if ([401, 404, 500].includes(error?.request?.status)) {
            handleError(error, toast);
            navigate('/login');
          }
        });
      }
    }
  };

  return (
    <div className="login-main">
      <Toast ref={toast} />
      {/* Left Side */}
      <div
        className="login-left"
        style={{ backgroundImage: `url("${LoginPic}")` }}
      ></div>

      {/* Right Side */}
      <div className="login-right">
        <div className="login-right-module">
          <div className='bayer-logo-heading'>
            <img src={BayerLogo} alt="Bayer Logo" className="login-logo" />
            <h1 className="login-logo-heading-text">FEC Reporting</h1>
          </div>
          

          <h2 className="login-heading">Hello Again!</h2>
          <p className="login-subheading">Welcome Back</p>

          <form onSubmit={handleLogin} className="login-form">
            <div className="login-email-field">
              <div className="input-icon-container">
                <img src={MailIcon} alt="email icon" className="input-icon" />
                <InputText
                  id="email"
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="login-input login-email-input"
                />
              </div>
            </div>

            <div className="login-password">
              <div className="input-icon-container">
                <img src={LockIcon} alt="password icon" className="input-icon input-password-icon" />
                <InputText
                  id="password"
                  type="password"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="login-input"
                />
              </div>
            </div>

            <Button
              type="submit"
              label="Login"
              className="login-button"
              loadingIcon="pi pi-spin pi-spinner"
              iconPos="right"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
